import { DefaultState } from "store/types";

export const CREATE_SESSION_SUCCESS = "CREATE_SESSION_SUCCESS";
export const CREATE_SESSION_FAILURE = "CREATE_SESSION_FAILURE";
export const DELETE_SESSION_SUCCESS = "DELETE_SESSION_SUCCESS";
export const RENEW_ROLE_SUCCESS = 'RENEW_ROLE_SUCCESS';
export const RENEW_ROLE_FAILURE = 'RENEW_ROLE_FAILURE';

export enum UserStatuses {
  Active = 'Active',
  Inactive = 'Inactive',
}

export enum Roles {
  Admin = 'Admin',
  Viewer = 'Viewer',
  SuperAdmin = 'SuperAdmin',
}

export interface UserData {
	id: string;
	firstName: string;
	lastName: string;
	role: Roles;
	status: UserStatuses;
}

interface CreateSessionSuccess {
	type: typeof CREATE_SESSION_SUCCESS;
	contents: {
		user: UserData;
	}
}

interface CreateSessionFailure {
	type: typeof DELETE_SESSION_SUCCESS | typeof CREATE_SESSION_FAILURE;
	message: ""
}

export interface CreateSessionData {
  username: string;
  password: string; 
}

export type SessionState = DefaultState & {
  isAuthenticated: boolean;
	user: UserData | null;
};

interface RenewRoleSuccess {
	type: typeof RENEW_ROLE_SUCCESS;
	contents: {
		user: UserData;
	}
}

interface RenewRoleFailure {
	type: typeof RENEW_ROLE_FAILURE;
	message: '';
}

export type SessionActionTypes = CreateSessionSuccess | CreateSessionFailure | RenewRoleSuccess | RenewRoleFailure;